import { Navigator as BaseNavigator, paginationHelper } from '@flipster/react/design-system-legacy/navigator';
import { Styles } from '@flipster/styled-system/css';

interface Props {
  current: number;
  per: number;
  total: number;
  onChange: (page: number) => void;
  css?: Styles;
}

export const Navigator = ({ onChange, css, ...restProps }: Props) => {
  return <BaseNavigator {...paginationHelper({ onChange, ...restProps })} css={css} />;
};
